import { useParams } from 'react-router-dom'

import type { ReactElement } from 'react'

import AuthGeneralInformation from './GeneralInformation'
import AuthDetailsGroup from './Groups'

import BackNavigation from '~/components/BackNavigation'
import LastUpdatedByCard from '~/components/LastUpdatedByCard'
import Layout from '~/components/Layouts/Layout'
import MwMLoader from '~/components/MwMLoader'
import ViewTitle from '~/components/ViewTitle'
import { useAuthorizationDetailsQuery } from '~/queries/iam-authorizations'

const AuthorizationDetails = (): ReactElement | null => {
  const { authId } = useParams<{ authId: string }>()

  const { data: authorization, isLoading } = useAuthorizationDetailsQuery(authId)

  if (isLoading) {
    return (
      <Layout>
        <MwMLoader category="item" />
      </Layout>
    )
  }

  if (!authorization) {
    return null
  }

  const { action, description, key, resource, roles, service, updated_at_ts, updated_by } = authorization

  const updatedBy = {
    date: updated_at_ts,
    name: updated_by.name,
    picture: updated_by.picture,
  }

  return (
    <Layout>
      <ViewTitle className="flex justify-space-between">
        <BackNavigation title="Authorizations" to="/mwm-users/authorizations" />
        <div className="flex align-center justify-center">Authorization detail</div>
        <LastUpdatedByCard updatedBy={updatedBy} />
      </ViewTitle>
      <AuthGeneralInformation
        action={action}
        authKey={key}
        description={description}
        resource={resource}
        service={service}
      />
      <AuthDetailsGroup roles={roles} />
    </Layout>
  )
}

export default AuthorizationDetails
